{
  "version": 1,
  "asset_id": "36111103-ecba-4a71-ba66-22f76a6800d1",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/36111103-ecba-4a71-ba66-22f76a6800d1/mrdrive-home.png",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/36111103-ecba-4a71-ba66-22f76a6800d1/mrdrive-home.png",
  "original_filename": "mrdrive-home.png",
  "size": 2000599,
  "content_type": "image/png",
  "created_at": "2026-07-17T00:25:19Z"
}
